import style from "./HeaderTitle.module.css";

export const HeaderTitle = ({ color, title }) => {
    return (
        <h1 className={style.title} style={{ color: color }}>
            {title}
        </h1>
    );
};
